import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaPigmentoResponse } from '../../responses/repositorio-tintas/lista-pigmento.response';

@Injectable({
  providedIn: 'root',
})
export class PigmentoService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public listaPigmento(idFabricante: number, paginaAtual: number): Observable<ListaPigmentoResponse> {
    const uri: string = `pigmento/listaPigmento/idFabricante/${idFabricante}?paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaPigmentoResponse>(environment.urlApiRepositorioTintas + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
